import { reactive, ref, watch } from 'vue';
import { apiRecipientList } from '@/request/api';

export default ({ currentGroupId }) => {

    const query = reactive({
        pageNum: 1,
        pageSize: 10,
    })
    const total = ref(0);
    const listData = ref([]);


    // 获取收件人列表
    async function setListData() {
        const params = { ...query };
        if (currentGroupId.value) {
            params['id'] = currentGroupId.value
        }
        const { data } = await apiRecipientList(params);
        total.value = data?.total || 0;
        listData.value = data?.list || [];
    }

    // 搜索
    function search() {
        query.pageNum = 1;
        setListData();
    }

    // 分页
    watch(() => query.pageNum, setListData);

    // 分组切换
    watch(() => currentGroupId.value, search);

    return { total, listData, query, setListData }
}